import {
  checkSingleSelectedImage,
  getCanvasResizeInfo,
  getSelectedImage,
  getTempElement,
  hasSingleSelectedText,
} from '../../../canvas/selectors';
import {
  getCurrentImprintAreaKey,
  getSidebarTabKey,
  getStudioItemType,
  getTempBackgroundImage,
  getTransparencyCoverProps,
  getWaitingCoverProps,
} from '../../../main/selectors';

import { createSelector } from '@reduxjs/toolkit';
import { elementStatus } from '../../../utils/constants';
import { getNextgenUiStatus } from '../../sidebar/LeftFlyout/selectors';
import { userImageType } from '../../../utils/constants';

export const hasTempElementOrBackground = createSelector(
  getTempElement,
  getTempBackgroundImage,
  (tempElement, tempBackground) => {
    return tempElement || (tempBackground && tempBackground.data) ? true : false;
  }
);

export const hasSingleSelectedElement = createSelector(
  checkSingleSelectedImage,
  hasSingleSelectedText,
  (hasSingleSelectedImage, hasSingleSelectedText) => {
    return hasSingleSelectedImage || hasSingleSelectedText;
  }
);

export const getMainPanelStoreData = createSelector(
  getCurrentImprintAreaKey,
  getStudioItemType,
  getWaitingCoverProps,
  getTransparencyCoverProps,
  getCanvasResizeInfo,
  checkSingleSelectedImage,
  hasSingleSelectedText,
  hasSingleSelectedElement,
  hasTempElementOrBackground,
  getSidebarTabKey,
  getNextgenUiStatus,
  getSelectedImage,
  (
    canvasKey,
    studioItemType,
    waitingCoverProps,
    transparencyCoverProps,
    canvasResizeInfo,
    hasSingleSelectedImage,
    hasSingleSelectedText,
    hasSingleSelectedElement,
    hasTempElementOrBackground,
    sidebarTabKey,
    nextgenUiStatus,
    selectedImage
  ) => {
    return {
      canvasKey,
      studioItemType,
      waitingCoverProps,
      transparencyCoverProps,
      canvasResizeInfo,
      hasSingleSelectedImage,
      hasSingleSelectedText,
      hasSingleSelectedElement,
      hasTempElementOrBackground,
      sidebarTabKey,
      nextgenUiStatus,
      selectedImage,
    };
  }
);

export const getFirstImage = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.imageDict,
  (currentCanvasKey, imageDict) => {
    if (imageDict && imageDict[currentCanvasKey] && imageDict[currentCanvasKey].length > 0) {
      const imagesOnCanvas = imageDict[currentCanvasKey].filter(
        (img) =>
          img.data.type !== userImageType.Verse &&
          img.data.type !== userImageType.Sentiment &&
          !(img.data.type === userImageType.Slogan && img.data.isOutside)
      );
      return imagesOnCanvas.length > 0 ? imagesOnCanvas[0] : null;
    }
    return null;
  }
);

export const getFirstText = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.textDict,
  (currentCanvasKey, textDict) => {
    if (textDict && textDict[currentCanvasKey] && textDict[currentCanvasKey].length > 0)
      return textDict[currentCanvasKey][0];
    return null;
  }
);

export const getSingleSelectedElement = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.imageDict,
  (state) => state.textDict,
  (currentCanvasKey, imageDict, textDict) => {
    let singleSelectedImage, singleSelectedText;
    if (imageDict[currentCanvasKey]) {
      singleSelectedImage = imageDict[currentCanvasKey].find(
        (image) => image.ui.status === elementStatus.SingleSelected
      );
    }
    if (textDict[currentCanvasKey]) {
      singleSelectedText = textDict[currentCanvasKey].find((text) => text.ui.status === elementStatus.SingleSelected);
    }
    return singleSelectedImage || singleSelectedText;
  }
);
